import type { ItemResponse } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import ItemResponseForm from "@memorang/ui/components/ItemResponseForm";
import { useDevice } from "@memorang/ui/useDevice";

type Props = {
	itemResponse: Extract<ItemResponse, { type: "form" }>;
	countryCode?: string;
	updateFormStates: (formStates: Record<string, string>) => void;
	disabled?: boolean;
	correct?: Record<string, { isCorrect?: boolean; response?: string }>;
};

const NoteCompletion = ({
	itemResponse,
	countryCode,
	updateFormStates,
	disabled = false,
	correct,
}: Props) => {
	const { isMobile } = useDevice();

	return (
		<Box paddingHorizontal={isMobile ? 16 : 0} maxWidth={250}>
			<ItemResponseForm
				formConfig={itemResponse}
				onWatch={updateFormStates}
				countryCode={countryCode}
				disabled={disabled}
				correct={correct}
			/>
		</Box>
	);
};

export default NoteCompletion;
